import Field from "../../ui/Field";

/* ── Invoice Step ── */
export default function StepInvoice({ wantsInvoice, onToggle, name, ruc, dv, onNameChange, onRucChange, onDvChange, errors }) {
    return (
        <div>
            <div className="ck-invoice-toggle" onClick={onToggle}>
                <div>
                    <p className="ck-toggle-label">Personalizar factura</p>
                    <p className="ck-toggle-sub">Agrega tu nombre y RUC o cédula</p>
                </div>
                <div className={`ck-toggle-switch${wantsInvoice ? ' on' : ''}`} />
            </div>
            {wantsInvoice && (
                <div className="ck-invoice-fields">
                    <Field label="Nombre / Razón social" id="inv-name" value={name} onChange={onNameChange}
                        placeholder="Ej. Juan Pérez o Empresa S.A." required error={errors?.name} />
                    <Field label="RUC o Cédula" id="inv-ruc" value={ruc} onChange={onRucChange}
                        placeholder="Ej. 8-123-456 o 000-000-0" required error={errors?.ruc}
                        hint="Ingresa tu RUC o número de cédula para validación" />
                    <Field label="DV" id="inv-dv"value={dv}
                        onChange={onDvChange}
                        placeholder="Ej. 00"
                        required
                        error={errors?.dv}
                    />
                </div>
            )}
            {!wantsInvoice && (
                <p className="ck-input-hint" style={{ padding: '.25rem 0' }}>
                    Se emitirá una factura consumidor final. Activa para personalizar los datos.
                </p>
            )}
        </div>
    );
}